/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_FailedInputs */

const vi_error_irrigation_schedule_failed = /** @type {(inputs: Error_Irrigation_Schedule_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đọc hoặc lưu được lịch tưới, vui lòng thử lại sau`)
};

/**

* @param {Error_Irrigation_Schedule_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_failed = /** @type {((inputs?: Error_Irrigation_Schedule_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_failed(inputs)
});